import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, FormControl, MenuItem, Select, TableCell, TableRow, Typography } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { IColumnMapping } from '../../../../../types/addressBook';

interface IProps {
  row: IColumnMapping;
  handleMapColumns: (id: string, value: string) => void;
  userHeaders: string[];
  isError: boolean;
  dataAction?: string;
  dataIndex?: number;
}

const TableMappingRow: React.FC<IProps> = ({ row, handleMapColumns, userHeaders, isError, dataAction, dataIndex }) => {
  const selectHeaderOptions = useMemo(() => {
    return userHeaders.map((header: string, index: number) => (
      <MenuItem key={header} value={header} data-action={`${dataAction}_select_option`} data-index={index}>
        {header}
      </MenuItem>
    ));
  }, [userHeaders, dataAction]);

  const clearOption = useMemo(() => {
    if (!row.isOptional) {
      return null;
    }

    return (
      <MenuItem key="not-mapped" value="" data-action={`${dataAction}_select_clear_option`}>
        Not mapped
      </MenuItem>
    );
  }, [row.isOptional, dataAction]);

  const renderSelectValue = useCallback((selected: string) => {
    return selected ? selected : <Typography>Not mapped</Typography>;
  }, []);

  return (
    <TableRow key={row.title} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell align="left">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2">{row.title}</Typography>
          <ArrowForwardIcon sx={{ color: 'grey.400', mr: 4 }} />
        </Box>
      </TableCell>
      <TableCell component="th" scope="row">
        <Box sx={{ pr: 4, py: 1.5 }}>
          <FormControl fullWidth variant="outlined" error={isError}>
            <Select
              value={row.mappedTo}
              onChange={(event) => handleMapColumns(row.id, event.target.value)}
              displayEmpty
              sx={{ height: 40, borderRadius: 0.5 }}
              inputProps={{ 'aria-label': 'Without label' }}
              renderValue={renderSelectValue}
              data-action={`${dataAction}_select`}
              data-index={dataIndex}
            >
              {clearOption}
              {selectHeaderOptions}
            </Select>
          </FormControl>
        </Box>
      </TableCell>
      <TableCell align="left">{row.sampleData}</TableCell>
    </TableRow>
  );
};

export default TableMappingRow;
